// @flow
import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const Wrapper = styled.div`
  border: ${props => (props.checkout ? theme.borderDefault : 0)};
  padding: ${props => (props.checkout ? '16px' : 0)};
`

export const TitleBox = styled.h4`
  margin: 0px;
  line-height: 2.95rem;
  padding: 0 1.2rem;
  font-size: ${theme.headingCheckout};
  font-family: ${theme.brandFontFamily};
  font-weight: 400;
  text-align: center;
  border-top: ${theme.borderDefault};
  border-left: ${theme.borderDefault};
  border-right: ${theme.borderDefault};
`

export default {
  container: {
    padding: '0px 16px'
  },
  button: {
    marginTop: 8
  }
}
